import React, { useState, forwardRef, useCallback, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Grid from '@mui/joy/Grid';
import Button from '@mui/joy/Button';
import Input from '@mui/joy/Input';
import Autocomplete from '@mui/joy/Autocomplete';
import Box from '@mui/joy/Box';
import { useNavigate } from 'react-router-dom'


/////////////////// Modal
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import Stack from '@mui/joy/Stack';
import Textarea from '@mui/joy/Textarea';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


//////////////////// API
import { getOthersOrders } from '../../Api/Orders';


import TableOthersOrders from '../../Components/OthersOrders/Table';


import AddIcon from '../../assets/icons/Add-icon.svg'
import SearchIcon from '@mui/icons-material/Search';

const schema = yup.object({
    image: yup.mixed().required("يرجى رفع صورة القسم"),
    title_ar: yup.string().required("هذا الحقل مطلوب"),
    title_en: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;


export default function OrderPricing() {
    const [currentTab, setCurrentTab] = useState(0);
    const [currentTabActive, setCurrentTabActive] = useState(0)
    const [orderManual, setOrderManual] = useState([]);
    const [open, setOpen] = useState(false);
    const [urlImageName, setUrlImageName] = useState("قم برفع شعار الماركة")
    const [imageDataTwo, setImageDataTwo] = useState(null)
    const [brandId, setBrandId] = useState(null)

    const [openModalConfirm, setOpenModalConfirm] = useState(false)
    const [loadingData, setLoadingData] = React.useState(false)
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const [searchData, setSearchData] = useState(null);
    const [roleId, setRoleId] = useState([])
    const [adminType, setAdminType] = useState(null)

    const navigate = useNavigate();



    const form = useForm({
        defaultValues: {
            image: '',
            title_ar: "",
            title_en: "",
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    return (
        <>

            <TableOthersOrders/>
        </>
    )
}